<template lang="pug">
  section
    FinanceMasterImport(
      backUrlPath="/tms/management/fixed-payment-rate"
      :uploadFileUrl="getUploadFileUrl"
      :uploadValidationUrl="getUploadValidationUrl"
      :commit-import-url="getCommitImportUrl"
      :fetchWorkListUrl="fetchWorkListUrl"
      :target-count-url="fetchWorkListCountUrl"
      :uploaded-at-action="uploadedAtAction"
      :isFilterError="isFilterError"
      :toggleFilterAction="toggleFilter"
    )
      template(v-slot:table)
        FixedPaymentImportWorkListTable(ref="WorkTable" :getListActionName="getListActionName" :isFilterError="isFilterError")
</template>

<script>
import FixedPaymentImportWorkListTable from "@/components/management/fixed-payment-rate/FixedPaymentImportWorkListTable";
import FinanceMasterImport from "@/components/import/FinanceMasterImport";
import AxiosBase from "@/assets/js/axios-base";
import { mapActions, mapGetters } from "vuex";

let axiosBase = new AxiosBase();

export default {
  components: {
    FixedPaymentImportWorkListTable,
    FinanceMasterImport
  },
  methods: {
    ...mapActions("financeImport", {
      uploadFile: "uploadImportFile",
      commitImport: "commitImport",
      clearWorkData: "clearWorkData",
      fetchWorkList: "fetchWorkList",
      toggleErrorOnly: "toggleErrorOnly"
    }),
    uploadedAtAction() {
      this.toggleErrorOnly(false);
      this.$refs.WorkTable.loadUploadData();
    },
    toggleFilter() {
      this.toggleErrorOnly(!this.isFilterError);
      this.$refs.WorkTable.loadUploadData();
    }
  },
  computed: {
    ...mapGetters("financeImport", {
      isFilterError: "isFilterError"
    }),
    getListActionName: () => "financeImport/fetchWorkList",
    getUploadFileUrl: () => axiosBase.getUrls().uploadFixedPaymentRateImportWork,
    getUploadValidationUrl: () => axiosBase.getUrls().uploadFixedPaymentRateImportWorkValidation,
    getCommitImportUrl: () => axiosBase.getUrls().uploadFixedPaymentRateImportWorkCommit,
    fetchWorkListUrl: () => axiosBase.getUrls().getFixedPaymentWorkList,
    fetchWorkListCountUrl: () => axiosBase.getUrls().getFixedPaymentWorkListCount
  }
};
</script>
